import { Link } from 'react-router-dom';
import { categories } from '@/mocks/novels';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 border-t border-primary-100 bg-primary-50">
      <div className="mx-auto grid grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-goblet-fill text-lg w-5 h-5 flex items-center justify-center"></i>
            </span>
            <span className="font-brand text-xl text-primary-700 mt-0.5">美丽的小蜜桃</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            美丽的小蜜桃汇聚玄幻、言情、历史、都市、仙侠等热门题材网络小说，提供在线阅读与及时的章节更新提醒，
            让每一位读者都能轻松发现好书、舒适追更。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a
              href="mailto:hello@peach-novel.com"
              aria-label="邮件联系"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-mail-line"></i>
            </a>
            <a
              href="#"
              aria-label="社交媒体"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-wechat-line"></i>
            </a>
            <a
              href="#"
              aria-label="社交媒体"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-weibo-line"></i>
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">热门题材</h4>
          <ul className="mt-4 space-y-2.5">
            {categories.slice(0, 5).map((c) => (
              <li key={c.name}>
                <Link
                  to={`/category?cat=${encodeURIComponent(c.name)}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {c.name}小说
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">网站导航</h4>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                首页
              </Link>
            </li>
            <li>
              <Link to="/category" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                分类书库
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                关于我们
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-100">
        <div className="mx-auto flex flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 md:flex-row md:px-8">
          <p>© {year} 美丽的小蜜桃 · 本站为小说阅读演示站点，所有内容均为虚构示例。</p>
          <p>热爱阅读，也尊重创作。</p>
        </div>
      </div>
    </footer>
  );
}